import { useState } from 'react';
import * as S from './styled';
import { processText } from '../../../../utils';

export const ExpandableText = ({ t }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleMoreClick = () => {
    setIsExpanded(true);
  };

  const text = isExpanded
    ? t('app_description_full')
    : t('app_description_preview');

  const processedText = processText(text);

  return (
    <S.ContentWrapper>
      <S.TextWrapper dangerouslySetInnerHTML={{ __html: processedText }} />
      {!isExpanded && (
        <S.ButtonWrapper>
          <S.MoreButton onClick={handleMoreClick}>{t('more')}</S.MoreButton>
        </S.ButtonWrapper>
      )}
    </S.ContentWrapper>
  );
};
